export default __webpack_public_path__ + "static/bodySectionBg-3ff3c23610820c030fd8cdaf8afc4cba.png";